import Vue from 'vue'
import VueTailwind from 'vue-tailwind'
import "whatwg-fetch"; // polyfill fetch (<2017)
import "promise-polyfill/src/polyfill";
import {
  TPagination, TDropdown
} from 'vue-tailwind/dist/components';

const settings = {
  't-pagination': {
    component: TPagination,
    props: {
      hideFirstLastControls: true,
      prevLabel: '<svg class="long-arrow-left" xmlns="http://www.w3.org/2000/svg" width="24" height="16" vsiewBox="0 0 24 16"><path d="M0,12.687H18.875l-4.75-4.813L16,6l8,8-8,8-1.875-1.875,4.75-4.813H0V12.685Z" transform="translate(24 21.999) rotate(180)" fill="#1a1919"/></svg>',
      nextLabel: '<svg class="long-arrow-right" xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16"><path d="M0,12.687H18.875l-4.75-4.813L16,6l8,8-8,8-1.875-1.875,4.75-4.813H0V12.685Z" transform="translate(24 21.999) rotate(-180)" fill="#fff"/></svg>',
      classes: {
        wrapper: 'pagination row justify-content-center align-items-center',
        activeElement: 'pagination-item',
        element: 'pagination-item',
        disabledElement: 'pagination-item disabled',
        activeButton: 'pagination-button current-page',
        disabledButton: 'pagination-button disabled',
        button: 'pagination-button',
        /*      
        ellipsisElement: 'w-8 h-8 border border-gray-200 hidden md:table-cell',
        ellipsis: ''
        */      
      },
    }
  },
  't-dropdown': {
    component: TDropdown,
    props: {
      fixedClasses: {
        button: 'toggler down-arrow',
        wrapper: 'dropdown-element-wrapper inline-flex flex-col',
        dropdownWrapper: 'dropdown-wrapper',
        dropdown: 'dropdown-items',
        enterClass: 'opacity-0 scale-95',
        enterActiveClass: 'transition transform ease-out duration-100',
        enterToClass: 'opacity-100 scale-100',
        leaveClass: 'opacity-100 scale-100',
        leaveActiveClass: 'transition transform ease-in duration-75',
        leaveToClass: 'opacity-0 scale-95'
      },
      classes: {
        button: 'bg-blue-500 hover:bg-blue-600',
        dropdown: 'bg-white'
      },
      variants: {
        danger: {
          button: 'bg-red-500 hover:bg-red-600',
          dropdown: 'bg-red-50'
        }
      }
    }
  }
}

const components = {
  // Add if needed, maybe dropdown
}

Vue.use(VueTailwind, settings);

const postTypeFiltering = new Vue({
  components: {
    VueTailwind,
  },
  watch: {
  },
  data: {
    ready: false,
    filters: {},
    terms: [],
    post_type: '',
    initial_count: 0,
    fetched_count: 0,
    initial_limit: 9,
    fetched_page: 1,
    current_page: 1,
    ordering: 'newest',
    orderingToggled: false,
    ordertexts: ID_select_texts,
    loading: false,
    page: 0,
    resultshtml: '',
    showordering: false,
    fetchedhtml: '',
    hideoriginalhtml: false,
    filter_row_toggled: false,
    visible: true,
    options: [
      { value: 'newest', text: ID_select_texts.newest },
      { value: 'oldest', text: ID_select_texts.oldest },
      { value: 'alphabet', text: ID_select_texts.alphabet }
      ]
  },
  created: function() {
    this.ready = true;
  },
  mounted: function() {
    //handle initial params / state
    try {
      const params = JSON.parse(this.$el.dataset.params);
      this.setInitialState(params.filters);
      this.initial_limit = params.initial_limit;
      this.initial_count = params.initial_count;
      this.fetched_count = params.initial_count;
      this.post_type = params.post_type;
    } catch (e) {
      console.log('initial filters handling error: ', e);
    }
  },
  methods: {
    setInitialState: function(filters) {
      this.filters = filters;
      
      //if no results
      if(!filters.initialcount) {
        this.hideoriginalhtml = false;
      }
    },

    paginationHandler: function() {
      const force_fetch = true;
      const paginate = true;
      this.fetchData( force_fetch, paginate );
    },

    orderingHandler: function( order ) {
      const force_fetch = true;
      this.ordering = order;
      this.toggleOrderingVisibility();
      this.fetchData( force_fetch );

      this.$refs.dropdown.doHide();
    },

    toggleFilterRow: function() {
      this.filter_row_toggled = (this.filter_row_toggled ? false : true );
    },

    toggleOrderingVisibility: function () {
      this.showordering = (this.showordering ? false : true );
    },

    clearFilters: function () {
      this.terms = [];
      const force_fetch = false;
      this.fetchData( force_fetch );
    },

    dropDownfocusHandler: function () {      
      this.$refs.dropdown.doShow();
    },

    dropDownblurHandler: function () {
      this.orderingToggled = this.$refs.dropdown.localShow;
    },

    searchOnFilterSelect: function() {
      const force_fetch = false;
      this.fetchData( force_fetch );
    },

    showResults: function () {
      this.$refs.results.scrollIntoView({behavior: 'smooth'});
    },
    
    doFiltering: function() {
      this.resultshtml = this.fetchedhtml;
      this.initial_count = this.fetched_count;
      this.current_page = 1;
    },
    
    fetchData: function ( force_fetch, paginate ) {
      
      this.loading = true;
      
      let payload = new FormData();
      let pagination_page = 1;

      if( paginate ) {
        pagination_page = this.current_page;
      }

      payload.append('terms', JSON.stringify(this.terms));
      payload.append('post_type', this.post_type);
      payload.append('current_page', pagination_page );
      payload.append('ordering', this.ordering);
      payload.append('force_fetch', force_fetch );

      fetch(resturl + "v1/get_filtered_posts", {
        method: 'POST',
        body: payload
      })
      .then(response => response.json() )
      .then(this.handleResults)
      .catch(ex => {
        this.loading = false;
      });
    },
    
    handleResults: function( json ) {
      this.loading = false;

      if(!this.hideoriginalhtml) {
        this.hideoriginalhtml = true;
      }
      
      if (json.code && json.message) {
        alert(json.message);
        return false;
      }

      if(json.html_content.length) {

        if( json.force_fetch === 'false' ) {
          this.fetchedhtml = json.html_content;
          this.fetched_count = json.post_count;  
        } else {
          this.resultshtml = json.html_content;
          this.fetched_count = json.post_count;
        }
      }
      
      return true;
    },
  }
});

document.addEventListener("DOMContentLoaded", function onDomReady() {
  document.removeEventListener("DOMContentLoaded", onDomReady, false);
  const elementID = "vue-post-type-filtering";
  const elements = document.querySelector( '[id^="'+elementID+'-"]' );

  if (elements) {
    console.log( 'found following elements: ' +elements.id )
    postTypeFiltering.$mount('#' + elements.id);
  }
});